import React, { useState } from "react";
import FadeSpinner from "../components/feedback/FadeSpinner";
import useFetchFeaturedListings from "../components/useFetchFeaturedListings/useFetchFeaturedListings";
import ListingItem from "../components/listings/ListingItem";
import { useParams } from "react-router-dom";
import Sidebar from "../components/sidebar/SideBar";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import ListingItemMobile from "../components/listings/ListingItemMobile";

const BargainsListings = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const param = location.state;
  const sellerId = param?.sellerId || params?.sellerId || ""; // get sellerId from state or params
  const { listings, loading, error } = useFetchFeaturedListings();

  const [carModel, setCarModel] = useState(param.carModel);
  const [priceRange, setPriceRange] = useState("");

  const ITEMS_PER_PAGE = 10;

  function isPartialMatch(target, search) {
    if (!target || !search) return false;

    const targetLower = target.toLowerCase();
    const searchLower = search.toLowerCase();

    let matches = 0;
    for (let char of searchLower) {
      if (targetLower.includes(char)) {
        matches++;
      }
    }

    // If more than 70% of the characters match
    return matches / searchLower.length >= 0.7;
  }

  // Filter listings based on user input
  const filteredListings = listings.filter((listing) => {
    const matchesCarModel = carModel
      ? isPartialMatch(listing.modelName, carModel)
      : true;
    const matchesPrice =
      priceRange && listing.price
        ? parseInt(listing.price) >= parseInt(priceRange.split("-")[0]) &&
          parseInt(listing.price) <= parseInt(priceRange.split("-")[1])
        : true;

    return matchesCarModel && matchesPrice;
  });

  if (loading) return <FadeSpinner />;
  if (error) return <p>{error}</p>;


  return (
    <>
      <Helmet>
        <title>
          {param
            ? `${carModel} for sale in Showrooms | NCPWheels`
            : "Search Cars"}
        </title>
        <meta
          name="description"
          content={`Find the best deals on ${carModel} cars for sale.`}
        />
        <meta
          name="keywords"
          content="ncp cars, non custom cars, ncp car, non custom paid cars, ncp cars for sale in swat, ncp cars for sale in swat pakistan, ncp car for sale in swat, ncp cars for sale in pakistan, ncp cars in pakistan for sale, ncp car for sale in pakistan, pakistan non custom cars for sale, non custom car for sale in pakistan, non custom cars in pakistan for sale, non custom cars for sale in pakistan, ncp car for sale, ncp cars for sale in swat olx, ncp cars for sale in chaman, ncp cars in swat, non custom paid cars in chaman, chaman border cars, ncp cars swat, swat ncp cars, non custom paid cars chaman, non custom cars in chaman, chaman non custom cars, chaman border non custom cars price, ncp cars in pakistan, cars for sale in swat, ncp cars swat chakdara, ncp swat chakdara motors, car for sale in swat, chaman border cars for sale in pakistan, non custom car price in chaman"
        />
      </Helmet>
      <div
        className="flex flex-row items-center gap-4 py-4 px-10 bg-gradient-to-br from-blue-700 via-purple-600 to-pink-500 shadow-2xl rounded-2xl mb-10 border-4 border-white"
        style={{
          boxShadow:
            "0 8px 32px 0 rgba(31, 38, 135, 0.37), 0 1.5px 6px 0 rgba(0,0,0,0.15)",
          backdropFilter: "blur(6px)",
        }}
      >
        <input
          type="text"
          placeholder="Search Car Model"
          value={carModel}
          onChange={(e) => setCarModel(e.target.value)}
          className="w-full sm:w-1/2 sm:mx-[24%] p-3 border-2 border-white bg-white/80 rounded-xl focus:ring-4 focus:ring-pink-400 focus:outline-none shadow-lg transition-all duration-300"
          style={{
            boxShadow: "0 2px 8px 0 rgba(0,0,0,0.12)",
          }}
        />
      </div>
      <div
        className="flex flex-col items-center gap-8 py-8 px-5 md:px-[15%] bg-gradient-to-br from-gray-100 via-white to-gray-300 shadow-2xl rounded-2xl mb-10 border-4 border-white"
        style={{
          boxShadow:
            "0 16px 40px 0 rgba(31, 38, 135, 0.25), 0 2px 8px 0 rgba(0,0,0,0.10)",
        }}
      >
        {filteredListings.map((listing) => (
          <div
            key={listing.id}
            className="w-full transform hover:scale-105 transition-transform duration-300"
            style={{
              perspective: "800px",
            }}
          >
            <div
              className="bg-white rounded-xl shadow-2xl border-2 border-gray-200"
              style={{
                boxShadow:
                  "0 8px 24px 0 rgba(31, 38, 135, 0.18), 0 1.5px 6px 0 rgba(0,0,0,0.10)",
                transform: "rotateY(-6deg) rotateX(2deg)",
              }}
            >
              <ListingItem
                data={listing}
                sellerId={listing.sellerId}
                id={listing.id}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BargainsListings;
